
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/stats",
      function () {
        return require("private-next-pages/about/stats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/stats"])
      });
    }
  